module.exports = __webpack_public_path__ + "img/ded-stock-creator1.e932dd93.png";